// Supabase client construction (Cloud-only per 2026-04-26 deviation).
// Uses the new asymmetric API key system: VITE_SUPABASE_PUBLISHABLE_KEY (sb_publishable_*).
// Service-role / secret keys MUST NOT have a VITE_ prefix and never reach the bundle (T-01-06-03).

import type { Database } from "@readose/schema/db"
import { createClient, type SupabaseClient } from "@supabase/supabase-js"

export function createSupabaseAnon(): SupabaseClient<Database> {
  const url = import.meta.env.VITE_SUPABASE_URL
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
  if (!url || !key) {
    throw new Error("VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set in .env.local")
  }
  return createClient<Database>(url, key, {
    auth: { persistSession: true, autoRefreshToken: true },
  })
}
